module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_NewCastle.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_NewCastle.png
// module id = 2192
// module chunks = 4